<template>
  <main
    id="stock"
    class="page-container stock-index"
    v-if="$route.name === 'listini'"
  >
    <p v-if="avvisoSchedeInPiu" class="listini-hint">
      {{ avvisoSchedeInPiu }}
    </p>
    <section class="cards-grid-stock">
      <router-link
        v-for="cat in categories"
        :key="cat.slug"
        :to="`/home/listini/${cat.slug}`"
        class="card-stock"
        :aria-label="cat.label"
      >
        <span class="icon-wrap">
          <i :class="cat.icon" aria-hidden="true"></i>
        </span>
        <span class="label">{{ cat.label }}</span>
      </router-link>
    </section>
  </main>
  <router-view />
</template>

<script>
/**
 * Indice dei listini.
 *
 * [sc-48583 / task 48599] Una scheda per ogni categoria scelta in
 * configurazione. L'elenco è centralizzato in `@/config/listiniCategories`,
 * dove è documentato anche il ripiego per chi la domanda non se l'è mai
 * sentita fare.
 */
import { listiniCategories } from "@/config/listiniCategories";

export default {
  name: "ListiniPage",
  computed: {
    /**
     * Cosa vende il cliente, dalla configurazione iniziale. È una computed e
     * non un dato fissato all'avvio del componente: il marchio arriva da una
     * chiamata non bloccante, quindi può non esserci ancora quando la pagina
     * si monta.
     */
    productCategories() {
      return this.$store.getters["company/branding"]?.productCategories;
    },
    itemCategoriesInUse() {
      return this.$store.getters["company/branding"]?.itemCategoriesInUse;
    },
    categories() {
      return listiniCategories(
        this.productCategories,
        this.itemCategoriesInUse
      );
    },
    /**
     * Perché in fondo alle schede scelte ne compare qualcun'altra.
     *
     * Senza una riga che lo dica, una scheda che non si è chiesta sembra un
     * errore del gestionale invece del posto in cui sono finiti i propri
     * articoli.
     */
    avvisoSchedeInPiu() {
      const inPiu = this.categories
        .filter((c) => c.contieneArticoli)
        .map((c) => `«${c.label}»`);
      if (inPiu.length === 0) return "";
      const nomi = inPiu.join(" e ");
      return inPiu.length === 1
        ? `${nomi} compare perché contiene articoli, anche se non l'hai scelta in configurazione.`
        : `${nomi} compaiono perché contengono articoli, anche se non le hai scelte in configurazione.`;
    },
  },
};
</script>

<style src="@/css/StockPage.css" />

<style scoped>
.listini-hint {
  margin: 0 0 12px;
  font-size: 13px;
  color: #666;
}
</style>
